export function getAssessmentThemeColor(assessmentId: string): string {
	const id = (assessmentId || '').toLowerCase();

	if (id.includes('screener')) {
		return '#4682e0';
	}
	if (id.includes('transform')) {
		return '#865ea1';
	}
	return '#243670';
}

function parseHexColor(hex: string): { r: number; g: number; b: number } | null {
	const normalized = (hex || '').trim().replace('#', '');
	if (normalized.length === 3) {
		return {
			r: parseInt(normalized[0] + normalized[0], 16),
			g: parseInt(normalized[1] + normalized[1], 16),
			b: parseInt(normalized[2] + normalized[2], 16),
		};
	}
	if (normalized.length === 6) {
		return {
			r: parseInt(normalized.slice(0, 2), 16),
			g: parseInt(normalized.slice(2, 4), 16),
			b: parseInt(normalized.slice(4, 6), 16),
		};
	}
	return null;
}

function mixHexWithWhite(hex: string, colorWeight: number): string {
	const rgb = parseHexColor(hex);
	if (!rgb) return 'rgb(255 255 255)';
	const whiteWeight = 1 - colorWeight;
	const r = Math.round(rgb.r * colorWeight + 255 * whiteWeight);
	const g = Math.round(rgb.g * colorWeight + 255 * whiteWeight);
	const b = Math.round(rgb.b * colorWeight + 255 * whiteWeight);
	return `rgb(${r} ${g} ${b})`;
}

export function getAssessmentCardBackgroundImage(assessmentId: string): string {
	const tint = getAssessmentThemeColor(assessmentId);
	const end = mixHexWithWhite(tint, 0.035);
	return `linear-gradient(to bottom, rgb(255 255 255) 0%, rgb(255 255 255) 85%, ${end} 100%)`;
}
